import React, { useEffect, useState } from "react";
import FormatUrl from "../../../../../../utils/UrlFormatter";
import moment from "moment";
import '../styles/DateSelector.css'

const DateSelector = ({
  clinicId,
  practitionerId,
  selectedDate,
  setSelectedDate,
}) => {
  const [dates, setDates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 7;

  useEffect(() => {
    const fetchDates = async () => {
      if (!practitionerId) {
        setDates([]);
        return;
      }

      setLoading(true);
      setNoData(false);

      try {
        const url = FormatUrl(
          `/get-slot/?clinic_id=${clinicId}&practitioner_id=${practitionerId}`
        );

        const res = await fetch(url, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });

        const data = await res.json();

        const slots = (data.slots || []).filter(
          (slot) => slot.status === "AV" && moment(slot.end).isAfter(moment())
        );

        const uniqueDates = [
          ...new Set(slots.map((slot) => moment(slot.start).format("YYYY-MM-DD"))),
        ];

        const formattedDates = uniqueDates.map((d) => ({
          label: moment(d).format("ddd, MMM D"),
          value: d,
        }));

        setDates(formattedDates);
        setNoData(formattedDates.length === 0);
        setStartIndex(0);
      } catch (err) {
        console.error("Error fetching dates:", err);
        setNoData(true);
      } finally {
        setLoading(false);
      }
    };

    fetchDates();
  }, [clinicId, practitionerId]);

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - visibleCount, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) =>
      Math.min(prev + visibleCount, dates.length - visibleCount)
    );
  };

  const handleSelectDate = (value) => {
    setSelectedDate(value);
  };

  if (!practitionerId || loading) return null;

  return (
    <div className="slot-row_manage_slots_settings date-slider-wrapper_manage_slots_settings">
      <label className="slot-label_manage_slots_settings">Select Date</label>
  
      {noData ? (
        <p className="slot-message_manage_slots_settings">No available dates</p>
      ) : (
        <div className="date-slider-bar_manage_slots_settings">
          <button
            className="date-nav-btn_manage_slots_settings"
            onClick={handlePrev}
            disabled={startIndex === 0}
            aria-label="Previous"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
            </svg>
          </button>
  
          <div className="date-capsule-row_manage_slots_settings">
            {dates.slice(startIndex, startIndex + visibleCount).map((date) => (
              <button
                key={date.value}
                className={`date-capsule_manage_slots_settings ${
                  selectedDate === date.value ? "selected" : ""
                }`}
                onClick={() => handleSelectDate(date.value)}
              >
                {date.label}
              </button>
            ))}
          </div>
  
          <button
            className="date-nav-btn_manage_slots_settings"
            onClick={handleNext}
            disabled={startIndex + visibleCount >= dates.length}
            aria-label="Next"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
  
};

export default DateSelector;
